import styled from '@emotion/styled';

export const H2 = styled.h2<{ color: string; center?: boolean; noMargin?: boolean }>`
    color: ${({ color }) => color};
    text-align: ${({ center }) => (center ? 'center' : 'left')};
    font-size: 1.75rem;
    line-height: 1.2;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: ${({ noMargin }) => (noMargin ? 0 : '2.5rem')};
`;
